import { InjectionToken } from '@angular/core';
import { NavItem } from '@ukam/shell/layouts/full/vertical/sidebar/nav-item/nav-item';

// Itens do menu lateral. Cada aplicação compõe os seus a partir dos fragmentos
// que as libs de feature exportam (laasNav, paasNav, adminNav, ...).
export const NAV_ITEMS = new InjectionToken<NavItem[]>('NAV_ITEMS');
